import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-version',
  templateUrl: './new-version.component.html',
  styleUrls: ['./new-version.component.css']
})
export class NewVersionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
